import { Box, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { BodyText } from '@/components/BodyText';

export const Row = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '6px 8px',
  borderRadius: '6px',
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.08),
  },
}));

// The Why control has to sit between the status and the date, and it cannot be inside the anchor:
// a button nested in an anchor is invalid markup, and stopping the click still leaves the anchor's
// own navigation to fire. So the link wraps every column up to the status and stretches its hit
// area over the whole row instead. Anything that needs its own click lifts itself above that area.
export const RowLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
  minWidth: 0,
  textDecoration: 'none',
  color: 'inherit',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '6px',
  },
});

// Only the control lifts itself above the row link's stretched hit area. The cell around it stays
// underneath, so the empty space beside a status still opens the row.
export const WhyControl = styled(Box)({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
});

export const EllipsisText = styled(BodyText)({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const CreatorCell = styled(EllipsisText)({
  flex: 1.2,
  minWidth: 0,
});

// Fixed rather than flexed, so the column holds still as relative times tick over. Each tile sizes
// it to the longest phrasing it can afford: date-fns runs up to "less than a minute ago" (157px),
// which only a tile with columns to spare can fit without squeezing its neighbours.
export const CreatedCell = styled(EllipsisText)({
  flexShrink: 0,
  width: '132px',
});

// Fixed to the widest badge, a running job at "In Progress 100%", so the column holds still as
// statuses change. The Why control shares the cell rather than claiming one of its own, so a failed
// row costs no more width than a completed one.
export const StatusCell = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '4px',
  flexShrink: 0,
  width: '136px',
});
